import type { ElementType } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

/** Icon representing the health domain. */
export const DomainHealthIcon: ElementType = FavoriteBorderIcon;

const DOMAIN_ICONS: Record<string, ElementType> = { health: DomainHealthIcon };

/** Returns the icon component for a domain's short key, or undefined when none is registered.
 *  Hides the concrete icon choice from callers. */
export function getDomainIcon(domainKey: string): ElementType | undefined {
  return DOMAIN_ICONS[domainKey];
}
